(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-bpp-gallery-auto]').forEach((root) => {
    if (prefersReducedMotion || root.dataset.bppReady === 'true') return;
    root.dataset.bppReady = 'true';

    const interval = Math.max(3000, Number(root.dataset.interval || 6500));
    const thumbnails = () => Array.from(root.querySelectorAll('.thumbnail-list__item button.thumbnail'));
    let timer;
    let pausedUntil = 0;
    let isVisible = true;
    let visibilityObserver;

    if ('IntersectionObserver' in window) {
      isVisible = false;
      visibilityObserver = new IntersectionObserver(
        ([entry]) => {
          isVisible = entry.isIntersecting && entry.intersectionRatio >= 0.15;
        },
        { threshold: [0, 0.15, 0.5, 1] }
      );
      visibilityObserver.observe(root);
    }

    const advance = () => {
      if (!isVisible || Date.now() < pausedUntil || document.hidden) return;
      const buttons = thumbnails();
      if (buttons.length < 2) return;
      const current = buttons.findIndex((button) => button.getAttribute('aria-current') === 'true');
      const next = buttons[(current >= 0 ? current + 1 : 1) % buttons.length];
      if (!next) return;
      root.dataset.bppAutoAdvance = 'true';
      next.click();
      window.setTimeout(() => {
        delete root.dataset.bppAutoAdvance;
      }, 50);
    };

    const pause = () => {
      pausedUntil = Date.now() + 12000;
    };

    root.addEventListener('pointerdown', pause, { passive: true });
    root.addEventListener('keydown', pause);
    root.addEventListener('focusin', pause);
    timer = window.setInterval(advance, interval);

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target?.contains(root)) {
        window.clearInterval(timer);
        visibilityObserver?.disconnect();
      }
    });
  });

  document.querySelectorAll('[data-bpp-bag-calculator]').forEach((calculator) => {
    if (calculator.dataset.bppReady === 'true') return;
    calculator.dataset.bppReady = 'true';

    const method = calculator.querySelector('[data-bpp-bag-method]');
    const cups = calculator.querySelector('[data-bpp-bag-cups]');
    const people = calculator.querySelector('[data-bpp-bag-people]');
    const duration = calculator.querySelector('[data-bpp-bag-duration]');
    const button = calculator.querySelector('[data-bpp-bag-calculate]');
    const result = calculator.querySelector('[data-bpp-bag-result]');
    const gramsOutput = calculator.querySelector('[data-bpp-bag-grams]');
    const bagsOutput = calculator.querySelector('[data-bpp-bag-sizes]');

    const calculate = () => {
      const gramsPerCup = Number(method?.value || 0);
      const cupsPerDay = Number(cups?.value || 1);
      const numberOfPeople = Number(people?.value || 1);
      const durationInDays = Number(duration?.value || 7);
      const totalGrams = gramsPerCup * cupsPerDay * numberOfPeople * durationInDays;

      const bagSizes = [];
      let remainingGrams = totalGrams;

      while (remainingGrams >= 1000) {
        bagSizes.push('1kg');
        remainingGrams -= 1000;
      }
      while (remainingGrams >= 500) {
        bagSizes.push('500g');
        remainingGrams -= 500;
      }
      while (remainingGrams >= 250) {
        bagSizes.push('250g');
        remainingGrams -= 250;
      }
      if (remainingGrams > 0) bagSizes.push('250g');

      if (gramsOutput) gramsOutput.textContent = `${totalGrams.toLocaleString()} grams`;
      if (bagsOutput) bagsOutput.textContent = bagSizes.join(', ');
      if (result) result.hidden = false;
    };

    button?.addEventListener('click', calculate);
  });

  const ensureGrindStyles = () => {
    if (document.getElementById('bpp-grind-select-styles')) return;
    const style = document.createElement('style');
    style.id = 'bpp-grind-select-styles';
    style.textContent = `
      .beanited-product-page.bpp-hero .bpp-grind-select-wrap{position:relative;max-width:100%;}
      .beanited-product-page.bpp-hero .bpp-grind-select{width:100%;min-height:46px;padding:0 44px 0 14px;border:1px solid rgba(26,37,54,.22);border-radius:10px;background:#fff;color:var(--bpp-heading,#1A2536);font:inherit;line-height:1.2;appearance:none;-webkit-appearance:none;cursor:pointer;}
      .beanited-product-page.bpp-hero .bpp-grind-select-wrap::after{content:'⌄';position:absolute;right:15px;top:50%;transform:translateY(-56%);font-size:18px;color:var(--bpp-heading,#1A2536);pointer-events:none;}
      .beanited-product-page.bpp-hero .bpp-grind-select:focus{outline:2px solid var(--bpp-accent,#FD9484);outline-offset:2px;}
      .beanited-product-page.bpp-hero fieldset[data-bpp-grind-enhanced='true']>input[type='radio'],
      .beanited-product-page.bpp-hero fieldset[data-bpp-grind-enhanced='true']>label:not(.form__label){display:none!important;}
    `;
    document.head.appendChild(style);
  };

  const enhanceGrindPicker = (scope = document) => {
    ensureGrindStyles();
    scope.querySelectorAll('.beanited-product-page.bpp-hero variant-selects fieldset.product-form__input--pill').forEach((fieldset) => {
      if (fieldset.dataset.bppGrindEnhanced === 'true') return;
      const legend = fieldset.querySelector(':scope > .form__label');
      const label = (legend?.textContent || '').replace(':', '').trim().toLowerCase();
      if (label !== 'grind') return;

      const radios = Array.from(fieldset.querySelectorAll(':scope > input[type="radio"]'));
      if (!radios.length) return;

      const wrap = document.createElement('div');
      wrap.className = 'bpp-grind-select-wrap';
      const select = document.createElement('select');
      select.className = 'bpp-grind-select';
      select.setAttribute('aria-label', 'Grind');

      radios.forEach((radio) => {
        const option = document.createElement('option');
        option.value = radio.value;
        option.textContent = radio.value;
        option.selected = radio.checked;
        option.disabled = radio.disabled || radio.classList.contains('disabled');
        select.appendChild(option);
      });

      select.addEventListener('change', () => {
        const target = radios.find((radio) => radio.value === select.value);
        if (target && !target.disabled && !target.classList.contains('disabled')) target.click();
      });

      fieldset.dataset.bppGrindEnhanced = 'true';
      wrap.appendChild(select);
      legend?.insertAdjacentElement('afterend', wrap);
    });
  };

  enhanceGrindPicker();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        enhanceGrindPicker(document);
        break;
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => enhanceGrindPicker(event.target));
})();
